export default "__VITE_ASSET__701f2938__"